import HTTP_METHODS from "src/general/constants/http/httpMethods";
import {
	AuthPostRequest as Req,
	AuthPostResponse as Res,
} from "src/business.InterfaceLayer/store/entities/auth.entity/redux/api/types/POST";
import { createBaseQueryDefinition } from "src/business.InterfaceLayer/store/services/utils.service/ResponseTransforms";
import MAIN_PATHS from "src/business.InterfaceLayer/store/mainPaths";
import { ApiQueryBuilder } from "src/business.InterfaceLayer/store/types/ApiQueryBuilder.type";
import AUTH_PATHS from "src/business.InterfaceLayer/store/entities/auth.entity/redux/paths";
import { AuthFromDtoPost as Dto } from "src/business.InterfaceLayer/store/entities/auth.entity/services/dto/from.dto";
import { Nullable } from "../../../../../types/Nullable.type";

const postRequestBaseDefinition = createBaseQueryDefinition(
	HTTP_METHODS.POST,
	MAIN_PATHS.USER
);

const authApiPostQueries = (build: ApiQueryBuilder) => ({
	postRegistrationCheckEmail: build.mutation<
		Nullable<Res.AuthRegistrationCheckEmail>,
		Req.AuthRegistrationCheckEmail
	>({
		query: (body) => ({
			...postRequestBaseDefinition({
				path: AUTH_PATHS.REGISTRATION_CHECK_EMAIL,
			}),
			body,
		}),
		transformResponse: Dto.authRegistrationCheckEmailFromDto,
	}),
	postRegistration: build.mutation<
		Nullable<Res.AuthRegistration>,
		Req.AuthRegistration
	>({
		query: (body) => ({
			...postRequestBaseDefinition({ path: AUTH_PATHS.REGISTRATION }),
			body,
		}),
		transformResponse: Dto.authRegistrationFromDto,
	}),
	postLogin: build.mutation<Nullable<Res.AuthLogin>, Req.AuthLogin>({
		query: (body) => ({
			...postRequestBaseDefinition({ path: AUTH_PATHS.LOGIN }),
			body,
		}),
		transformResponse: Dto.authLoginFromDto,
		invalidatesTags: [`${MAIN_PATHS.AUTHORIZATION}TAG`],
	}),
	postRecoveryPasswordEmail: build.mutation<
		Nullable<Res.RecoveryPasswordEmail>,
		Req.RecoveryPasswordEmail
	>({
		query: (body) => ({
			...postRequestBaseDefinition({
				path: AUTH_PATHS.RECOVERY_PASSWORD_EMAIL,
			}),
			body,
		}),
		transformResponse: Dto.recoveryPasswordEmailFromDto,
	}),
	postRecoveryPassword: build.mutation<
		Nullable<Res.RecoveryPassword>,
		Req.RecoveryPassword
	>({
		query: (body) => ({
			...postRequestBaseDefinition({ path: AUTH_PATHS.RECOVERY_PASSWORD }),
			body,
		}),
		transformResponse: Dto.recoveryPasswordFromDto,
	}),
	postEditEmail: build.mutation<Nullable<Res.EmailEdit>, Req.EmailEdit>({
		query: (body) => ({
			...postRequestBaseDefinition({ path: AUTH_PATHS.EDIT_EMAIL }),
			body,
		}),
		transformResponse: Dto.guestAuthLoginFromDto,
		invalidatesTags: [`${MAIN_PATHS.AUTHORIZATION}TAG`],
	}),
});

export default authApiPostQueries;
